import React from "react";
import UserList from "./UserList";
import { RemovableUser } from "components/Removables/RemovableUser";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";

interface Props extends Omit<ModalPickerProps<server.dto.UserSmall>, "onChange"> {
  onChange: (newValue: server.dto.UserSmall, environment: server.dto.Environments) => void

  canChooseDeactivated?: boolean
  canChooseExternal?: boolean

  customLabel?: string
  excludeUsers?: number[]
}

const UserModalPicker = (props: Props) => {
  const { onChange, canChooseDeactivated, canChooseExternal, customLabel, excludeUsers, ...rest } = props;
  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={customLabel ?? RESX.SoUser.Users}
    modalSize="mini"
    
    
    renderModalContent={(closeModal) => <UserList
      excludedUsers={excludeUsers}
      onUserSelected={(user, environment) => {
        closeModal();
        props.onChange(user, environment);
      }}
      canChooseDeactivated={canChooseDeactivated}
      canChooseExternal={canChooseExternal}
    />}
    renderRemovable={(props) => <RemovableUser {...props} />}
    onChange={() => { props.onChange(undefined, undefined); }}
    {...rest}
  />;
};

export default UserModalPicker;